/** Matches API datetimes in "YYYY-MM-DD HH:MM:SS" format (space separator, no timezone). */
const SPACE_SEPARATED_DATETIME = /^\d{4}-\d{2}-\d{2} /;

/** Matches ISO datetimes that carry a T separator but no trailing Z or +hh:mm offset. */
const T_SEPARATED_DATETIME_NO_ZONE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/;

/**
 * Reads an API date string as UTC without losing time data.
 *
 * The API sends datetimes with no timezone marker, in two shapes — space-separated
 * ("YYYY-MM-DD HH:MM:SS") and T-separated ("YYYY-MM-DDTHH:MM:SS") — which browsers
 * would otherwise read as local time and skew by the visitor's offset. Both are
 * matched explicitly rather than by testing for an absent zone: appending Z to
 * anything unrecognised turns date-only and written inputs into values Firefox and
 * Safari reject outright.
 *
 * @param iso - The API date string.
 * @returns The parsed date; an Invalid Date when the input is unparseable.
 */
export const parseServerDate = (iso: string) => {
  if (SPACE_SEPARATED_DATETIME.test(iso)) {
    return new Date(`${iso.replace(' ', 'T')}Z`);
  }

  if (T_SEPARATED_DATETIME_NO_ZONE.test(iso)) {
    return new Date(`${iso}Z`);
  }

  return new Date(iso);
};
